import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../config/api";
import { resetDataFailure, resetDataRequest, resetDataSuccess, resetDataSubmitFailure, resetDataSubmitRequest, resetDataSubmitSuccess, resetPasswordVerficationSubmitRequest, resetPasswordVerficationSubmitSuccess, resetPasswordVerficationSubmitFailure } from "../slice/resetSlice";
import { config } from "../../../config/global";

// API Post URL for Reset Password
const Reset_API_URL = config.UNLOCK_ACCOUNT_API;
const Reset_SUBMIT_API_URL = config.UNLOCK_ACCOUNT__NEW_API;
const Reset_PASSWORD_EMAIL_VERFICATION_API_URL = config.RESET_PASSWORD_AFTER_EMAIL_VERFICATION;
const robEnabled = sessionStorage?.getItem("isROPEnabled") === "true" ? true : false;
const fetchResetData = async resetPayload => {
  let data = {
    mode: "no-cors",
    headers: {
      "content-type": "application/json"
    }
  };
  let resetPayloadData = {
    memberId: resetPayload?.memberId?.toUpperCase(),
    emailAddress: resetPayload?.emailAddress,
    surname: resetPayload?.surname?.toUpperCase(),
    birthDate: resetPayload?.birthDate
  };
  let ropResetPayloadData = {
    memberId: resetPayload?.memberId?.toUpperCase(),
    emailAddress: resetPayload?.emailAddress
  };
  const response = robEnabled ? await api.post(Reset_SUBMIT_API_URL, ropResetPayloadData, data) : await api.post(Reset_API_URL, resetPayloadData, data);
  return response;
};
const fetchResetSubmitData = async resetPayload => {
  let data = {
    mode: "no-cors",
    headers: {
      "content-type": "application/json"
    }
  };
  let resetSubmitPayloadData = {
    memberId: resetPayload.memberId?.toUpperCase(),
    emailAddress: resetPayload.emailAddress
  };
  const response = await api.post(Reset_SUBMIT_API_URL, resetSubmitPayloadData, data);
  return response;
};
const fetchResetPasswordVerficationData = async resetPayload => {
  let data = {
    mode: "no-cors",
    headers: {
      "content-type": "application/json"
    }
  };
  const response = await api.post(Reset_PASSWORD_EMAIL_VERFICATION_API_URL, resetPayload, data);
  return response;
};
// Get data generator function
function* getReset(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchResetData, payload);
    yield put(resetDataSuccess(response.data));
  } catch (error) {
    yield put(resetDataFailure(error.response.data));
  }
}

// Get data generator function
function* getResetSubmit(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchResetSubmitData, payload);
    yield put(resetDataSubmitSuccess(response.data));
  } catch (error) {
    yield put(resetDataSubmitFailure(error.response.data));
  }
}

// Get data generator function
function* getResetPasswordVerficationData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchResetPasswordVerficationData, payload);
    yield put(resetPasswordVerficationSubmitSuccess(response.data));
  } catch (error) {
    yield put(resetPasswordVerficationSubmitFailure(error.response.data));
  }
}
export function* watchReset() {
  yield takeLatest(resetDataRequest.type, getReset);
}
export function* watchResetSubmit() {
  yield takeLatest(resetDataSubmitRequest.type, getResetSubmit);
}
export function* watchGetResetPasswordVerficationData() {
  yield takeLatest(resetPasswordVerficationSubmitRequest.type, getResetPasswordVerficationData);
}